
import { RevLink } from '@ds/components/Link'

import { ROUTES } from '@router'

import translations from './AboutUsLink.translations'

export default {
  components: {
    RevLink,
  },

  computed: {
    ROUTES: () => ROUTES,
    translations: () => translations,
  },
}
